<template>
  <div>
    <ok-cancel-modal
      :title="$t('health.nutritionalPlan.templateSelector')"
      :ok-button="$t('commons.ok')"
      :cancel-button="$t('commons.cancel')"
      v-on:ok="onOk"
      v-on:cancel="$emit('close')">
      <div
        slot="body">
        <search-input
          :focus="true"
          class="search-input"
          v-on:input="onChangeFilter"/>
        <div
          class="margin-top-xl plan-list">
          <h3
            class="margin-bottom-l">
            {{ $t('health.nutritionalPlan.templates') }}
          </h3>
          <radio
            v-for="(plan, index) in getFilteredPlans"
            :key="index"
            v-on:change="onVariableSelected(plan)"
            :checked="isChecked(plan)"
            radio-size="s"
            :id="String(plan.id)"
            :label="plan.name"/>
        </div>
      </div>
    </ok-cancel-modal>
  </div>
</template>

<script>
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import SearchInput from '@/components/shared/SearchInput';
import Radio from '@/components/shared/forms/Radio';

export default {
  name: 'AddPlanModal',
  components: {
    OkCancelModal,
    SearchInput,
    Radio
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    plans: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.selectedTemplate = value;
      }
    }
  },
  data () {
    return {
      planFilter: '',
      selectedTemplate: this.value
    };
  },
  computed: {
    getFilteredPlans () {
      if (this.planFilter !== '') {
        return this.plans.filter(plan => {
          return plan.name.toUpperCase().includes(this.planFilter.toUpperCase());
        });
      }
      return this.plans;
    }
  },
  methods: {
    isChecked (plan) {
      return this.selectedTemplate !== undefined &&
      this.selectedTemplate !== null &&
      this.selectedTemplate.id === plan.id ? 'checked' : '';
    },
    onVariableSelected (plan) {
      this.selectedTemplate = plan;
    },
    onOk () {
      if (this.selectedTemplate.id) {
        this.$emit('input', this.selectedTemplate);
      }
      this.$emit('close');
    },
    onChangeFilter (filter) {
      this.planFilter = filter;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

h3 {
  color: $jamaicol;
}

.plan-list {
  min-height: calc(100vh / 2);
  max-height: calc(100vh / 2);
  overflow-y: auto;
}

.search-input {
  margin-bottom: $sp-margin;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/AddPlanModal.vue